<template>
  <transition name="dialog" appear>
    <div class="dialog-mask" @click="close">
      <div class="dialog-wrapper">
        <div class="dialog-container" @click.stop="" :style="{width: dialogWidth}">
          <div class="dialog-header">
            <span class="title">{{title}}</span>
            <icon v-if="closeButton" icon-class="plus-cricle" @click="close" />
          </div>
          <slot></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<style lang="less" scoped>
  .dialog-mask{
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
    .dialog-wrapper{
      display: table-cell;
      vertical-align: middle;
      .dialog-container{
        width: 90%;
        margin: 0px auto;
        background-color: #fff;
        border-radius: 5px;
        box-shadow: 0 2px 14px 0 rgba(75,119,174,0.25);
        overflow: hidden;
        transition: all .3s ease;
        .dialog-header{
          width: 100%;
          height: 60px;
          display: flex;
          justify-content: center;
          align-items: center;
          background: #F7F7F7;
          .title{
            font-size: 16px;
            color: @black;
            font-weight: bold;
          }
        }
      }
    }
  }
  // 动画
  .dialog-enter {
    opacity: 0;
  }

  .dialog-leave-active {
    opacity: 0;
  }

  .dialog-enter .dialog-container,
  .dialog-leave-active .dialog-container {
    -webkit-transform: translateY(-20px);
    transform: translateY(-20px);
  }
</style>

<script type="text/javascript">
  export default {
    props: {
      header: {
        type: Boolean,
        default: true,
      },
      title: {
        type: String,
        default: '警告',
      },
      closeButton: {
        type: Boolean,
        default: false,
      },
      dialogWidth: {
        type: String
      }
    },
    data() {
      return {}
    },
    methods: {
      close() {
        this.$emit('close')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/dialog.vue